export default async (date, region = 'england-and-wales') => {
  try {
    //date format from api: "date": "2019-01-01",
    const targetDate = new Date(date).toISOString().split('T')[0];

    const response = await fetch('https://www.gov.uk/bank-holidays.json');
    if (!response.ok) {
      return false;
    }
    const data = await response.json();

    return data[region].events.some(holiday => holiday.date === targetDate);
  } catch {
    return false;
  }
};
